import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22b832d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "text-md" }
const _hoisted_4 = { class: "mb-8 font-space text-medium font-bold text-xl" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" We are almost at the end of the Citizen Lab! ")
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mt-4 text-justify" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" We are almost at the end of the Citizen Lab! We just have a couple of questions for you before we say goodbye. ")
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "mt-6 mb-6 text-justify" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "1", -1))
const _hoisted_12 = { class: "mt-16 mb-6 text-justify" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "2", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pl-16 flex-col items-center flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/girl_reading.svg",
    alt: "Magnets with fridge",
    class: "w-2/4"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_4, _hoisted_6)), [
              [_directive_t, 'almost-end.title']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9)), [
              [_directive_t, 'almost-end.subtitle']
            ]),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(" – " + _toDisplayString(_ctx.$t('almost-end.question1')), 1)
            ]),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q1 === 'insufficient'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.q1) = $event)),
                type: "radio",
                name: "q1",
                value: "insufficient"
              }, null, 512), [
                [_vModelRadio, _ctx.q1]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.insufficient')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q1 === 'barely'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.q1) = $event)),
                type: "radio",
                name: "q1",
                value: "barely"
              }, null, 512), [
                [_vModelRadio, _ctx.q1]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.barely')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q1 === 'okay'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.q1) = $event)),
                type: "radio",
                name: "q1",
                value: "okay"
              }, null, 512), [
                [_vModelRadio, _ctx.q1]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.okay')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q1 === 'satisfying'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.q1) = $event)),
                type: "radio",
                name: "q1",
                value: "satisfying"
              }, null, 512), [
                [_vModelRadio, _ctx.q1]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.satisfying')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q1 === 'great'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.q1) = $event)),
                type: "radio",
                name: "q1",
                value: "great"
              }, null, 512), [
                [_vModelRadio, _ctx.q1]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.great')), 1)
            ], 2),
            _createElementVNode("p", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" – " + _toDisplayString(_ctx.$t('almost-end.question2')), 1)
            ]),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q2 === 'no'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.q2) = $event)),
                type: "radio",
                name: "q2",
                value: "no"
              }, null, 512), [
                [_vModelRadio, _ctx.q2]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.no')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q2 === 'prioritize'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.q2) = $event)),
                type: "radio",
                name: "q2",
                value: "prioritize"
              }, null, 512), [
                [_vModelRadio, _ctx.q2]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.prioritize')), 1)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["block my-1 font-bold", {selected:_ctx.q2 === 'will'}])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.q2) = $event)),
                type: "radio",
                name: "q2",
                value: "will"
              }, null, 512), [
                [_vModelRadio, _ctx.q2]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('almost-end.will-pay')), 1)
            ], 2),
            _withDirectives(_createElementVNode("button", {
              class: "btn orange-button mt-8 min-w-12 mx-auto block sm:mx-0",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, null, 512), [
              [_directive_t, 'buttons.submit']
            ])
          ]),
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}